import { Data } from 'complex-data'
import { RequireMethod, requireOptionType } from 'complex-require/src/Require'
import { responseType } from 'complex-require/src/Rule'
import { isCompleteUrl } from 'complex-utils'
import requireData from '../../require'

export type apiDataTargetFinalType = keyof requireOptionType
export type apiDataTargetType = apiDataTargetFinalType | 'inherit'

export interface urlConfigType {
  pre: string,
  service: string
}

export interface ApitDataInitOption {
  name: string
  url: string
  token?: requireOptionType['token']
  urlConfig?: urlConfigType
  method?: RequireMethod
  data?: apiDataTargetType[]
  format?: requireOptionType['$format']
}

const getTypeList = ['get', 'delete']

function appendProp (requireData: requireOptionType, propList: apiDataTargetFinalType[], args: unknown[]) {
  if (propList && propList.length > 0 && args && args.length > 0) {
    for (let i = 0; i < propList.length; i++) {
      const prop = propList[i]
      const data = args[i]
      if (data !== undefined) {
        if (prop !== 'url') {
          requireData[prop] = data
        } else {
          requireData.url += data
        }
      }
    }
  }
}

class ApiData<A extends unknown[] = unknown[], R extends responseType = responseType> extends Data {
  static formatApi = function (url: string, urlConfig?: urlConfigType) {
    if (urlConfig) {
      if (!isCompleteUrl(url)) {
        if (urlConfig.pre && isCompleteUrl(urlConfig.pre)) {
          return urlConfig.pre + url
        }
        if (urlConfig.service) {
          return urlConfig.service + url
        }
      }
    }
    return url
  }
  name: string
  url: string
  token?: requireOptionType['token']
  urlConfig: {
    pre: string
    service: string
  }
  method: RequireMethod
  data: apiDataTargetFinalType[]
  format?: requireOptionType['$format']
  constructor(initOption: ApitDataInitOption) {
    super()
    this.name = initOption.name
    this.url = initOption.url
    this.token = initOption.token
    this.urlConfig = initOption.urlConfig || {
      pre: '',
      service: ''
    }
    this.method = initOption.method || 'get'
    this.format = initOption.format
    if (initOption.data) {
      this.data = initOption.data.map(dataStr => {
        if (dataStr === 'inherit') {
          dataStr = getTypeList.indexOf(this.method) > -1 ? 'params' : 'data'
        }
        return dataStr
      })
    } else {
      this.data = []
    }
  }
  require(...args: A) {
    const method = this.method
    const url = ApiData.formatApi(this.url, this.urlConfig)
    const requireOption: requireOptionType = {
      url: url,
      token: this.token,
      $format: this.format
    }
    appendProp(requireOption, this.data, args)
    const promise = requireData[method](requireOption)
    return promise as Promise<R>
  }
}

export default ApiData
